import { REQUIRED_WORKFLOW_IDS, workflowById } from "../catalog";
import { useWorkflows } from "../context/WorkflowsContext";

/**
 * "Running Organize Into Folders · Step 2 of 5", "Running Retitle Exhibits
 * and 2 More · 3 of 9 Done", or how far the case has come.
 */
export const useRunLine = (): string => {
  const w = useWorkflows();
  if (w.current) {
    const of = w.runIds.length;
    const waiting =
      w.views.find((v) => v.id === w.current)?.status === "queued";
    const { title } = workflowById(w.current);
    if (w.active.length > 1) {
      const open = new Set(["queued", "running", "needs-you"]);
      const ended = w.runIds.filter(
        (id) => !open.has(w.views.find((v) => v.id === id)?.status ?? "")
      ).length;
      return `Running ${title} and ${
        w.active.length - 1
      } More · ${ended} of ${of} Done`;
    }
    const step = w.runIds.indexOf(w.current) + 1;
    return `${waiting ? "Queued" : "Running"} ${title}${
      of > 1 ? ` · Step ${step} of ${of}` : ""
    }`;
  }
  return `${w.done} of ${REQUIRED_WORKFLOW_IDS.length} Done`;
};
